<template>
  <section class="section">
    <h2>Built for Real Community Competitions</h2>
    <p class="lead">
      From Nairobi estates to county leagues and academies, organizers can run tournaments with less stress.
    </p>

    <div class="use-cases">
      <span v-for="item in examples" :key="item">{{ item }}</span>
    </div>
  </section>
</template>

<script setup>
const examples = [
  "Local estate tournaments",
  "School competitions",
  "Church and youth leagues",
  "Corporate tournaments",
];
</script>

<style scoped>
.section {
  padding: 1.5rem 0 0.75rem;
}

h2 {
  margin: 0;
  font-size: 1.45rem;
  color: var(--text-color1);
  font-weight: 800;
}

.lead {
  margin: 0.75rem 0 1rem;
  color: var(--text-color1);
  opacity: 0.88;
}

.use-cases {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.use-cases span {
  color: var(--text-color1);
  background: var(--background-color2);
  border: 1px solid var(--border-color-hover1, #e5e7eb);
  border-radius: 999px;
  padding: 0.45rem 0.85rem;
  font-size: 0.93rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.use-cases span:hover {
  transform: translateY(-2px);
  border-color: var(--border-color-hover);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}
</style>
